import React, { useState } from 'react';
import FormTextField from 'components/FormTextField';
import StyledButton from 'components/Button';
import { CancelModalContainer } from '../CancelBookingModalBody/style';
import { CrossIcon } from 'assets/icons';
import { useSetRecoilState, useRecoilState } from 'recoil';
import { cancelReasonModalOpenState, cancelGroupId, cancelBookingId, cancelBookingFee, canceledBookingIdState, canceledGroupIdState} from 'states/ModalStates/atoms';
import { useMutation } from '@apollo/client';
import { WEBSITE_CANCEL_BOOKING } from 'graphql/service';
import { useHistory } from 'react-router-dom';
import { reloadTrips } from  'states/CommonStates/atoms';
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';


const CancelReasonModalBody: React.FC = () => {


  const debug = false;

  const { showGlobalError, showGlobalMessage} = useGlobalAlerts();

  const setOpenCancelReasonModal = useSetRecoilState(cancelReasonModalOpenState)
  const [groupId, setCancelModalGroupId] = useRecoilState(cancelGroupId)
  const [bookingId, setCancelModalBookingId] = useRecoilState(cancelBookingId)
  const [cancellationReason, setCancellationReason] = useState('')
  const [cancelError, setCancelError] = useState(false)

  const [, setCancelModalBookingFee] = useRecoilState(cancelBookingFee)

  const [, setCanceledBookingId] = useRecoilState(canceledBookingIdState);
  const [, setCanceledGroupId] = useRecoilState(canceledGroupIdState);

  const [, setReloadTripsNow] = useRecoilState(reloadTrips);

  const history = useHistory()

  const resetCancelModalState = () => {
    setCancelModalGroupId('');
    setCancelModalBookingId('');
    setOpenCancelReasonModal(false);
    setCancelModalBookingFee('');
  };


  const [websiteCancelBooking] = useMutation(WEBSITE_CANCEL_BOOKING, {
    onCompleted: (data) => {
      
      const currentGroupId = groupId;
      const currentBookingId = bookingId;

      resetCancelModalState();
  
      if (data?.websiteCancelBooking?.success) {
        if (currentGroupId.length > 0) {
          setCanceledGroupId(currentGroupId);
          showGlobalMessage(
            "Your booking has been successfully canceled, and confirmation will be sent to your email."
          );
  
          const bookingUrl = '/account/bookings/' + currentGroupId;
  
          if (debug) {
            console.log('bookingUrl: ', bookingUrl);
          }
  
          setReloadTripsNow(true);
          history.push(bookingUrl);
  
          if (debug) {
            console.log('Group cancel successfully, data:', data);
          }
        } else if (currentBookingId.length > 0) {
          setCanceledBookingId(currentBookingId);
          showGlobalMessage(
            "Your room has been successfully removed, and confirmation will be sent to your email."
          );
  
          if (debug) {
            console.log('Room cancel successfully, data:', data);
          }
  
          setReloadTripsNow(true);
        }
      } else {
        if (debug) {
          console.log('Cancel failed');
        }
        showGlobalError('Cancel failed');
      }
    },
    onError: (error) => {
      if (debug) {
        console.log('Cancel failed with error: ', error);
      }

      resetCancelModalState();
  
      showGlobalError(`Cancel failed: ${error.message || 'Unknown error'}`);
    },
  });

  const handleCancelBooking = () => {
    if (cancellationReason.trim().length === 0) {
      setCancelError(true);
      return;
    }
  
    if (groupId.length > 0) {
      websiteCancelBooking({
        variables: {
          data: {
            groupId,
            cancellationReason,
          },
        },
      });
    } else if (bookingId.length > 0) {
      websiteCancelBooking({
        variables: {
          data: {
            bookingId,
            cancellationReason,
          },
        },
      });
    } else {
      if (debug) {
        console.log('Cancel failed');
      }
      showGlobalError('Cancel failed');
    }
  };

  return (
    <CancelModalContainer>
      <div
        className="closeButton"
        onClick={() => {
          setOpenCancelReasonModal(false);
        }}>
        <CrossIcon />
      </div>
      <div className="cardTitle">Cancel your booking</div>
      <div className="contentTitle">{groupId.length>0 ? "Please let us know why you’re cancelling your booking." : "Are you sure you want to remove this room from your booking?"} </div>
      <div className="description">
        Your feedback is important to us and helps us improve our services. How could we have made your experience better? <span className='warning'>*</span>
      </div>
      <div className='textareaContainer'>
        <FormTextField
          className="textField"
          maxRows={6}
          minRows={6}
          multiline
          error={cancelError}
          value={cancellationReason}
          onChange={(e) => {
            setCancellationReason(e.target.value);
            setCancelError(false);
          }}
        />
      </div>
      <div className='buttonContainer'>
        <div
          className='link'
          onClick={handleCancelBooking}
        >
           {groupId.length>0 ? "Cancel Booking" : "Remove Room"}
        </div>
        <StyledButton
          width="142px"
          height="48px"
          onClick={() => setOpenCancelReasonModal(false)}
        >
          Keep {groupId.length>0 ? "Booking" : "Room"}
        </StyledButton>
      </div>
    </CancelModalContainer>
  );
};

export default CancelReasonModalBody
